<template>
<div class="chapter">
<div class="inner_page">
<div class="display-image1" style="margin-top:10%;"><a id="pagevi"></a><a id="pagevii"></a><a id="pageviii"></a><img alt="image" src="images/line.png"/></div>
<div class="fm-title">CONTENTS</div>
<div class="display-image2"><img alt="image" src="images/sequer.png"/></div>
<div class="toc1"><a href="#/ch01#toc1a" id="toc1">1. Blood Sacrifice in Texas</a></div>
<div class="toc1"><a href="#/ch02#toc2a" id="toc2">2. Planting Seeds</a></div>
<div class="toc1"><span href="#/ch03#toc3a" id="toc3" title="Link target outside of Sample">3. Growing Season</span></div>
<div class="toc1"><span href="#/ch04#toc4a" id="toc4" title="Link target outside of Sample">4. First Harvest: Portrait of a Budding Magnate</span></div>
<div class="toc1"><span href="#/ch05#toc5a" id="toc5" title="Link target outside of Sample">5. Recruiting New Hands for the Second Crop: The Band Begins to Gather</span></div>
<div class="toc1"><span href="#/ch06#toc6a" id="toc6" title="Link target outside of Sample">6. The $60,000 Incubator</span></div>
<div class="toc1"><span href="#/ch07#toc7a" id="toc7" title="Link target outside of Sample">7. Salad Days</span></div>
<div class="toc1"><span href="#/ch08#toc8a" id="toc8" title="Link target outside of Sample">8. The Worm in the Apple</span></div>
<div class="toc1"><span href="#/ch09#toc9a" id="toc9" title="Link target outside of Sample">9. Cutting the Jell-O</span></div>
<div class="toc1"><span href="#/ch10#toc10a" id="toc10" title="Link target outside of Sample">10. Haddock Almondine and Chicken-Fried Steak</span></div>
<div class="toc1"><span href="#/ch11#toc11a" id="toc11" title="Link target outside of Sample">11. The Worm Gnaws Deeper</span></div>
<div class="toc1"><span href="#/ch12#toc12a" id="toc12" title="Link target outside of Sample">12. Scalloped Squash and Spinach Pudding</span></div>
<div class="toc1"><span href="#/ch13#toc13a" id="toc13" title="Link target outside of Sample">13. Yeast Rolls, Biscuits, and Two Kinds of Cornbread</span></div>
<div class="toc1"><span href="#/ch14#toc14a" id="toc14" title="Link target outside of Sample">14. Cherry Cobbler and Coconut Cream Pie</span></div>
<div class="toc1"><span href="#/ch15#toc15a" id="toc15" title="Link target outside of Sample">15. Deviled Eggs and Stuffed Jalapeños</span></div>
<div class="toc1"><span href="#/ch16#toc16a" id="toc16" title="Link target outside of Sample">16. Hot Coffee, Iced Tea, Pink Lemonade, or Just Plain Water</span></div>
<div class="toc1"><span href="#/ch17#toc17a" id="toc17" title="Link target outside of Sample">17. Condiments on the Side</span></div>
<div class="toc1"><span href="#/ch18#toc18a" id="toc18" title="Link target outside of Sample">18. Dirty Dishes</span></div>
<div class="toc1"><span href="#/ch19#toc19a" id="toc19" title="Link target outside of Sample">19. Over, Fork Over</span></div>
<div class="toc1"><span href="#/ch20#toc20a" id="toc20" title="Link target outside of Sample">20. Leftovers</span></div>
<div class="toc1" style="margin-top:1.8em;margin-bottom:1.8em;"><span href="#/epilogue#toc21a" id="toc21" title="Link target outside of Sample">Epilogue</span></div>
<div class="toc1"><span href="#/afterword#toc22a" id="toc22" title="Link target outside of Sample">Afterword by Carol Johnston</span></div>
<div class="toc1"><span href="#/tree#toc23a" id="toc23" title="Link target outside of Sample">Luby Family Tree (<i>partial</i>)</span></div>
<div class="toc1"><span href="#/ack#toc24a" id="toc24" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="toc1"><span href="#/selectref#toc25a" id="toc25" title="Link target outside of Sample">Selected Sources</span></div>
<div class="toc1"><span href="#/index#toc26a" id="toc26" title="Link target outside of Sample">Index</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?44b9fe3e